import React from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// react-select components
import Select, { components } from "react-select";

// Soft UI Dashboard PRO React base styles
import colors from "assets/theme/base/colors";

// Custom styles for SoftSelect
import styles from "components/SoftSelect/styles";

const { ValueContainer, Placeholder } = components;

const CustomValueContainer = ({ children, ...props }) => {
  return (
    <ValueContainer {...props} className="select-value-container">
      <Placeholder {...props} isFocused={props.isFocused} className="select-placeholder-container">
        {props.selectProps.label}{" "}
        {props.selectProps.isRequired ? <span style={{ color: "#ff667c" }}>*</span> : ""}
      </Placeholder>
      {React.Children.map(children, (child) =>
        child && child.type !== Placeholder ? child : null
      )}
    </ValueContainer>
  );
};

const SoftSelect = ({
  size = "medium",
  error = false,
  success = false,
  onMenuOpen,
  menuPlacement = "auto",
  useDefaultValueContainer = false,
  ref,
  ...rest
}) => {
  const { light } = colors;

  const onOpen = () => {
    setTimeout(() => {
      const listbox = document.querySelector(".css-1e83rmc-menu");

      if (listbox) {
        const clearHighlight = () => {
          const node = listbox.querySelector(".css-1qru4v0-option");

          if (node) {
            node.className = "css-1ourupj-option";
          }
        };

        clearHighlight();

        listbox.removeEventListener("mouseleave", clearHighlight);

        listbox.addEventListener("mouseleave", clearHighlight);
      }
    }, 0.5);
  };

  return (
    <Select
      {...rest}
      ref={ref}
      styles={styles(size, error, success)}
      menuPlacement={menuPlacement}
      menuPortalTarget={document.body}
      menuPosition="fixed"
      onMenuOpen={() => {
        if (typeof onMenuOpen === "function") {
          onMenuOpen();
        }
        onOpen();
      }}
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary25: light.main,
          primary: light.main
        }
      })}
      components={
        useDefaultValueContainer
          ? rest.components
          : { ...rest.components, ValueContainer: CustomValueContainer }
      }
    />
  );
};
// Typechecking props for the SoftSelect
SoftSelect.propTypes = {
  size: PropTypes.oneOf(["small", "medium", "large"]),
  error: PropTypes.bool,
  success: PropTypes.bool
};

export default SoftSelect;
